export default {
      id: "pencil-usage",
      viewBox: "0 0 14 14",
      url: "/" + "img/marilyn-ui.svg#pencil",
      toString: function () {
        return this.url;
      }
    }